// extracted by mini-css-extract-plugin
export var active = "_5g-1";
export var activeSubdued = "_5g-2";
export var compact = "_5g-3";
export var pulse = "_5g-4";
export var settingHighlightPulse = "_5g-5";
export var wrapper = "_5g-0";